import React from 'react';

import { Skeleton } from '../../components/skeleton';
import { TooltipIcon } from '@/new/components/tooltip-icon';

const numberFormatter = new Intl.NumberFormat();
export function StatisticBlock({
  title,
  value,
  tooltip,
}: {
  title: string;
  value?: number;
  tooltip?: React.ReactNode;
}) {
  return (
    <div className="flex min-w-min flex-col justify-between gap-2 rounded-lg border bg-gray-50 p-4 px-5">
      <div className="flex items-center gap-1.5">
        <p className="text-xs font-medium tracking-wider text-gray-500 uppercase">{title}</p>
        {tooltip !== undefined && (
          <TooltipIcon tooltipContent={tooltip} side="right" triggerClassName="flex text-gray-400" />
        )}
      </div>
      <div className="flex h-9 items-center text-3xl font-semibold tracking-tight text-gray-900">
        {value !== undefined ? (
          <span className="animate-in fade-in">{numberFormatter.format(value)}</span>
        ) : (
          <Skeleton className="h-7 w-16 bg-gray-200/70" />
        )}
      </div>
    </div>
  );
}
